module.exports = __webpack_public_path__ + "static/media/tinywow_2430AmbrosiaBlütemaleKopie_colored_55475373.c2d64ffe.jpg";